import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { Spin } from "antd";

function redirectForType(type) {
  if (type === "admin") return "/dashboard";
  if (type === "teacher") return "/teacher-dashboard";
  if (type === "student") return "/student-dashboard";
  return "/";
}

// Guards /dashboard/* — requires an authenticated admin session.
export function AdminRoute({ children }) {
  const { session, profile, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spin size="large" />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  if (profile?.type !== "admin") {
    return <Navigate to={redirectForType(profile?.type)} replace />;
  }

  return children;
}

// Guards /student-dashboard — requires an authenticated student session.
export function StudentRoute({ children }) {
  const { session, profile, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spin size="large" />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  if (profile?.type !== "student") {
    return <Navigate to={redirectForType(profile?.type)} replace />;
  }

  return children;
}

// Guards /teacher-dashboard — requires an authenticated teacher session.
export function TeacherRoute({ children }) {
  const { session, profile, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spin size="large" />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  if (profile?.type !== "teacher") {
    return <Navigate to={redirectForType(profile?.type)} replace />;
  }

  return children;
}
